import { useEffect } from 'react';
import { useParams, useLocation, Navigate } from 'react-router-dom';
import { getOffer, withSubId, pick } from '../offers/config';
import { captureAttribution } from '../offers/attribution';

// ============================================================
// /go/:slug  -> REDIRECCION DE SALIDA AL AFILIADO
// ------------------------------------------------------------
// Por que existe:
//   1. Los botones apuntan a una ruta propia y legible, no a una URL
//      larga de impact pegada en el HTML.
//   2. Un solo lugar donde vive el link real. Si Kovo cambia el link o
//      entra otra oferta, se toca offers/config.ts y nada mas.
//   3. Aqui se dispara AffiliateClick y se construye el subId con los
//      parametros de la campana antes de salir.
//
// NOMBRE DEL EVENTO: AffiliateClick, NO Lead.
// Un click de salida no es un lead: Blinkblis no captura correo ni
// telefono en este paso. Si algun dia se captura, ahi si toca Lead.
//
// OJO: esta ruta depende de que el JS haya cargado. Si prefieres que el
// boton apunte directo al link de impact (mas resistente, una peticion
// menos), cambia USE_GO_ROUTE a false en pages/Offer.tsx.
// ============================================================

export function Go() {
  const {
    slug
  } = useParams();
  const {
    search
  } = useLocation();
  const offer = getOffer(slug);
  useEffect(() => {
    if (!offer) return;

    // Asegura que los parametros de esta URL queden guardados antes de
    // construir el subId (por si entraron directo a /go/...).
    captureAttribution();
    const w = window as any;
    if (typeof w.fbq === 'function') {
      w.fbq('trackCustom', 'AffiliateClick', {
        network: offer.network,
        brand: offer.brand,
        offer: offer.slug,
        content_category: pick(offer.category, 'en')
      });
    }
    const destino = withSubId(offer.affiliateUrl, offer.slug);
    // replace: no deja esta ruta en el historial, asi el boton "atras"
    // devuelve a la pagina de oferta y no a un bucle de redireccion.
    window.location.replace(destino);
  }, [offer, search]);
  if (!offer) return <Navigate to="/" replace data-id="element-393" data-mp="1zatsezv0103q" />;
  return <div className="min-h-screen bg-background text-white flex flex-col items-center justify-center gap-5 px-6 text-center" data-id="element-394" data-mp="1zbvf61ldnb1a">
      <div className="w-10 h-10 rounded-full border-2 border-white/15 border-t-accent animate-spin" data-id="element-395" data-mp="1pla9xvb7789e" />
      <p className="text-white/50 text-[15px] font-light" data-id="element-396" data-mp="1km7g770o4ogq">
        {`Redirecting to ${offer.brand}…`}
      </p>
      <a href={withSubId(offer.affiliateUrl, offer.slug)} rel="nofollow sponsored noopener noreferrer" className="text-accent text-[14px] underline hover:no-underline" data-id="element-397" data-mp="1gkub4z5egpav">
        {`Continue to ${offer.brand}`}
      </a>
    </div>;
}